import { createUseStyles } from "react-jss";
const useStyles = createUseStyles((theme) => ({
  inputsContainer: {
    height: 160,
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    "& button": {
      "&:hover,&:active,&:focus": {
        // background: theme.brandingBlue,
      },
    },
  },

  content: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  footer: {},
  successMessage: {
    color: theme.authenticationResendColor,
    fontSize: 10,
    top: "50%",
    right: "50%",
    transform: "translate(50%, 50%)",
    position: "absolute",
    fontWeight: "bolder",
  },
  limiter: {
    // width: "100%",
    // margin: "0 auto",
  },
  smallPageLogo: {
    display: "none",
  },
  resend: {
    textAlign: "center",
    color: `${theme.authenticationResendColor}!important`,
    fontSize: 12,
    background: "none!important",
    border: "none!important",
    width: "100%",
    "&:hover": {
      cursor: "pointer",
      color: `${theme.authenticationResendColor}!important`,
    },
  },
  linkText: {
    fontSize: 13,
    lineHeight: 1.5,
    color: theme.authenticationLinkTextColor,
  },
  containerLogin100: {
    width: "100%",
    minHeight: "100%",
    height: "100%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    padding: "15px",
    background: `linear-gradient(-135deg, ${theme.loginBgColor1}, ${theme.loginBgColor2})`,
  },
  wrapLogin100: {
    width: "960px",
    background: theme.wrapLoginBg,
    borderRadius: "10px",
    overflow: "hidden",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    padding: [80, 80, 60, 80],
  },
  logosBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  bsiLogo: {
    width: 100,
    height: 100,
    marginBottom: "1rem",
    "& img": {
      maxWidth: "100%",
    },
    backgroundImage: "url(" + theme.bsiLogo + ")",
    backgroundPosition: "center",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
  },
  login100Pic: {
    width: 316,
    height: 316,
    "& img": {
      maxWidth: "100%",
      // maxHeight: "100%",
    },
    backgroundImage: "url(" + theme.logoImage + ")",
    backgroundPosition: "center",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
  },
  login100FormTitle: {
    fontSize: "20px",
    color: theme.authTitleColor,
    lineHeight: 1.2,
    textAlign: "center",
    width: "100%",
    display: "block",
    paddingBottom: "54px",
    position: "relative",
  },
  wrapInput100: {
    position: "relative",
    width: "100%",
    zIndex: 1,
    marginBottom: 10,
  },
  input100: {
    fontSize: 15,
    lineHeight: 1.5,
    color: theme.authInputColor,
    display: "block",
    width: "100%",
    background: theme.authInputBg1,
    height: "50px",
    borderRadius: "25px",
    padding: "0 30px 0 68px",
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
    "&[type=number]": {
      MozAppearance: "textfield",
    },
  },
  symbolInput: {
    fontSize: "15px",
    display: "flex",
    alignItems: "center",
    position: "absolute",
    borderRadius: "25px",
    bottom: "0",
    left: "0",
    width: "100%",
    height: "100%",
    paddingLeft: "35px",
    pointerEvents: "none",
    color: theme.authInputSymbolColor,
    transition: "all 0.4s",
  },
  containerLogin100FormBtn: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  "@media screen and (min-width:577px) and (max-width: 768px)": {
    wrapLogin100: {
      padding: [100, 80, 33, 100],
      background: "transparent",
    },
  },
  "@media screen and (max-width: 576px)": {
    wrapLogin100: {
      padding: [0, 15, 33, 15],
      background: "transparent",
    },
  },
  "@media screen and (min-width:769px) and (max-width: 992px)": {
    login100Pic: {
      width: 240,
      height: 240,
    },
  },
  "@media (max-width: 768px)": {
    form: {
      width: "100%",
    },
    smallPageLogo: {
      width: "100%",
      height: "15vh",
      marginBottom: "1rem",
      display: "block!important",
      backgroundImage: "url(" + theme.logoImage + ")",
      backgroundPosition: "center",
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
    },
    input100: {
      background: theme.authInputBg2,
    },
    linkText: {
      color: `${theme.authenticationLinkTextColor2}!important`,
    },
    logosBox: {
      width: "100%",
    },
    bsiLogo: {
      width: 50,
      height: 50,
    },
    login100Pic: {
      display: "none",
    },
    login100FormTitle: {
      paddingBottom: 20,
    },
  },
  appVersion: {
    position: "fixed",
    bottom: "0",
    width: "100%",
    textAlign: "center",
  },
}));
export { useStyles };
